export default __webpack_public_path__ + "static/media/bag.e68e6255.ogg";